module.exports = __webpack_public_path__ + "img/ch85.ba285f08.png";